import React, { createContext, useCallback, useState } from "react";

export const AlertContext = createContext({
    show: (message, options) => { },
    hide: (id) => { },
});

export function AlertProvider({ children }) {
    const [alerts, setAlerts] = useState([]);

    const remove = useCallback((id) => {
        setAlerts((prev) => prev.filter((a) => a.id !== id));
    }, []);

    const show = useCallback((message, options = {}) => {
        const {
            type = "info",
            timeout = 5000, // ms, set null/0 for persistent
            id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        } = options;

        const alert = { id, type, message, timeout };
        // add to top
        setAlerts((prev) => [alert, ...prev]);

        if (timeout && timeout > 0) {
            setTimeout(() => {
                remove(id);
            }, timeout);
        }

        return id;
    }, [remove]);

    const hide = useCallback((id) => remove(id), [remove]);

    return (
        <AlertContext.Provider value={{ show, hide, alerts, setAlerts }}>
            {children}
        </AlertContext.Provider>
    );
}
